import { FiPlay } from "react-icons/fi";
import type { Clip } from "../types";
import { formatDate, formatDuration } from "../utils";
import { BangerButton } from "./BangerButton";
import { DeleteClipButton } from "./DeleteClipButton";
import { ShareClipButton } from "./ShareClipButton";

interface GalleryCardProps {
  clip: Clip;
  bangered: boolean;
  bangerBusy: boolean;
  isAdmin: boolean;
  deleting: boolean;
  onOpen: (clip: Clip) => void;
  onBanger: (clip: Clip) => void;
  onDelete: (clip: Clip) => void;
  onShare: (clip: Clip) => void;
}

export function GalleryCard({ clip, bangered, bangerBusy, isAdmin, deleting, onOpen, onBanger, onDelete, onShare }: GalleryCardProps) {
  return (
    <article className="clip-card">
      <button className="clip-card-open" type="button" onClick={() => onOpen(clip)} aria-label={`Play ${clip.title}`}>
        <span className="clip-card-media">
          <img
            src={clip.thumbnailUrl}
            alt=""
            loading="lazy"
            decoding="async"
            onLoad={(event) => event.currentTarget.classList.add("loaded")}
          />
          <span className="clip-play"><FiPlay aria-hidden="true" /></span>
          <span className="clip-duration">{formatDuration(clip.durationSeconds)}</span>
        </span>
        <span className="clip-card-copy">
          <strong title={clip.title}>{clip.title}</strong>
          <span>{formatDate(clip.recordingDate)} · Recorded</span>
          <span>{formatDate(clip.uploadedAt)} · Uploaded</span>
          <span className="clip-uploader">by {clip.uploaderName}</span>
        </span>
      </button>
      <BangerButton
        count={clip.bangerCount}
        bangered={bangered}
        busy={bangerBusy}
        placement="card"
        onBanger={() => onBanger(clip)}
      />
      <ShareClipButton placement="card" onShare={() => onShare(clip)} />
      {isAdmin && (
        <DeleteClipButton
          deleting={deleting}
          placement="card"
          onDelete={() => onDelete(clip)}
        />
      )}
    </article>
  );
}
